// extracted by mini-css-extract-plugin
export default {"header":"CustomBoardHeader_header__l1wYi","arrow":"CustomBoardHeader_arrow__kk4Co"};